import type { Agent } from '@fingerprintjs/fingerprintjs'

let fpPromise: Promise<Agent> | null = null

export function useFingerprintJS() {
  const getVisitorId = async (): Promise<string> => {
    if (!fpPromise) {
      const FingerprintJS = await import('@fingerprintjs/fingerprintjs')
      fpPromise = FingerprintJS.default.load()
    }

    const fp = await fpPromise
    const result = await fp.get()
    return result.visitorId
  }

  return {
    getVisitorId
  }
}
